







import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe, PageTitle },
})
export default class OrderPreviousDetailIframe extends Vue {
  private get remoteSrc() {
    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/fulfillment/order/previous-detail' + '?' + queryString;

    return src;
  }
}
